import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { client } from "../../../../../../graphql";
import { shared } from "../../../../../graphql/shared";
import { MenuContext } from "../../../../../contexts/shared";
import { SidebarLayout } from "../../../../../components/shared";
import { MainMenu } from "../../../../../components/coordinator/shared";
import { AnnouncementsSection } from "../../../../../components/shared/";
import { Navbar, Summary } from "../../../../../components/admin/batches/show";
import {
  BatchDetailsContextProvider
} from "../../../../../contexts/admin/batches";
import {
  CreateAnnouncementModalProvider
} from "../../../../../contexts/shared/create-annoucement-modal";


export const AnnouncementsIndex = () => {
  const { id } = useParams();
  const { setMenuState } = useContext(MenuContext);

  const { data, loading, error, refetch } = useQuery(
    shared.queries.getAnnouncements,
    {
      fetchPolicy: "network-only",
      variables: {
        where: {
          batch: {
            id
          }
        }
      },
      client
    }
  );

  setMenuState({
    openKeys: ["programs"],
    selectedKeys: ["batches"]
  });

  return (
    <BatchDetailsContextProvider>
      <CreateAnnouncementModalProvider batchId={id} refetch={refetch}>
        <SidebarLayout menu={<MainMenu />}>
          <Summary />
          <Navbar selectedKeys={["announcements"]} />
          <AnnouncementsSection
            refetch={refetch}
            data={data}
            error={error}
            loading={loading} />
        </SidebarLayout>
      </CreateAnnouncementModalProvider>
    </BatchDetailsContextProvider>
  );
};
